
window.toggleVisablePassword = function(passwordFieldId,eyeIconId) {


    const passwordField = document.getElementById(passwordFieldId);
    const eye = document.getElementById(eyeIconId);

        const type = passwordField.getAttribute("type") === "password" ? "text" : "password";
        passwordField.setAttribute("type", type);

         if(type === "text"){
             eye.classList.remove("bi-eye");
             eye.classList.add("bi-eye-slash");
         }else{
             eye.classList.add("bi-eye");
             eye.classList.remove("bi-eye-slash");
         }

}



